import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy-loaded public pages
const LandingPage = React.lazy(() => import('../pages/LandingPage'));
const Login = React.lazy(() => import('../pages/Login'));
const Register = React.lazy(() => import('../pages/Register'));
const VerifyAccount = React.lazy(() => import('../pages/VerifyAccount'));
const LeadActivation = React.lazy(() => import('../pages/LeadActivation'));
const EmailVerificationPage = React.lazy(() => import('../pages/EmailVerificationPage'));
const ForgotPassword = React.lazy(() => import('../pages/ForgotPassword'));
const ResetPassword = React.lazy(() => import('../pages/ResetPassword'));
const SetPasswordOAuth = React.lazy(() => import('../pages/SetPasswordOAuth'));
const TradieDirectory = React.lazy(() => import('../pages/TradieDirectory'));
const TradieProfile = React.lazy(() => import('../pages/TradieProfile'));
const TradieRegisterMultiStep = React.lazy(() => import('../pages/TradieRegisterMultiStep'));
const ClaimBusiness = React.lazy(() => import('../pages/ClaimBusiness'));
const ClaimListing = React.lazy(() => import('../pages/ClaimListing'));
const PricingPlans = React.lazy(() => import('../pages/PricingPlans'));
const ContactUs = React.lazy(() => import('../pages/ContactUs'));
const AdvertiseWithUs = React.lazy(() => import('../pages/AdvertiseWithUs'));
const SandboxInfo = React.lazy(() => import('../pages/SandboxInfo'));
const OTPVerification = React.lazy(() => import('../pages/OTPVerification'));
const TermsOfService = React.lazy(() => import('../pages/TermsOfService'));
const PrivacyPolicy = React.lazy(() => import('../pages/PrivacyPolicy'));
const BookTradiePage = React.lazy(() => import('../pages/BookTradiePage'));
const ContactTradiePage = React.lazy(() => import('../pages/ContactTradiePage'));

const publicRoutes = [
  { path: '/', element: <LandingPage /> },
  { path: '/sandboxes', element: <SandboxInfo /> },
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Register /> },
  { path: '/verify-account', element: <VerifyAccount /> },
  // Token-based activation link emailed to a sales lead — no login required.
  { path: '/lead-activation/:token', element: <LeadActivation /> },
  { path: '/verify-email', element: <EmailVerificationPage /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password', element: <ResetPassword /> },
  // New Google/Apple signups land here (with a one-time ?token=) to set a
  // password — the account is created only after they submit it.
  { path: '/set-password', element: <SetPasswordOAuth /> },
  { path: '/directory', element: <TradieDirectory /> },
  { path: '/register-tradie', element: <TradieRegisterMultiStep /> },
  { path: '/join-tradie', element: <TradieRegisterMultiStep /> },
  { path: '/claim-business/:id', element: <ClaimBusiness /> },
  { path: '/claim/:token', element: <ClaimListing /> },
  { path: '/pricing', element: <PricingPlans /> },
  { path: '/contact', element: <ContactUs /> },
  { path: '/advertise', element: <AdvertiseWithUs /> },
  { path: '/tradie/:id', element: <TradieProfile /> },
  { path: '/tradie/:id/book', element: <BookTradiePage /> },
  { path: '/tradie/:id/contact', element: <ContactTradiePage /> },
  { path: '/verify-otp', element: <OTPVerification /> },
  { path: '/terms', element: <TermsOfService /> },
  { path: '/privacy', element: <PrivacyPolicy /> },
];

export default publicRoutes;
